import { render, staticRenderFns } from "./FullScreenCom.vue?vue&type=template&id=cdd62096&scoped=true"
import script from "./FullScreenCom.vue?vue&type=script&lang=js"
export * from "./FullScreenCom.vue?vue&type=script&lang=js"
import style0 from "./FullScreenCom.vue?vue&type=style&index=0&id=cdd62096&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd62096",
  null
  
)

export default component.exports